import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {Application} from "types/Application"
import {SortProps} from "./list/ApplicationsTable"
import {FilterValue} from "antd/es/table/interface"
import {cleanFilters} from "../../utils/cleanFilters"

type ReturnedType = {
    status: "success"
    data: {
        content: Application[]
        id: number
        create_at: string
        target_date: string
        cities: {id: number; name: string}[]
        terminals: {id: number; name: string}[]
        page_number: number
        page_size: number
        total_elements: number
    }
}

/**
 * Фильтры таблицы (значения antd) + диапазон дат создания в виде UTC ISO строк.
 */
type ApplicationFilter = Partial<Record<string, FilterValue | string | null | undefined>>

export interface FetchApplicationsParams {
    sort?: SortProps
    pageable: {page: number; size: number}
    filter?: ApplicationFilter
}

export const fetchApplications = createAsyncThunk<ReturnedType, FetchApplicationsParams, AppThunkProps>(
    "application/fetch",
    async (data, {signal}) => {
        const cleanedParams = cleanFilters({data})

        return api.post<ReturnedType>("/applications/list", cleanedParams.data, {signal})
    }
)
